import React from 'react';

import Container from 'components/Container';

const Footer = () => {
  return (
    <footer>
      <Container>
      
      </Container>
    </footer>
  );
};

export default Footer;
